// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports-panel {
  width: 100%;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 15px;
  overflow-y: auto;
  box-sizing: border-box;
  color: var(--text-primary);
}

.reports-panel hr {
  border-color: var(--border);
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/SummaryPanel.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".reports-panel {\n  width: 100%;\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 15px;\n  overflow-y: auto;\n  box-sizing: border-box;\n  color: var(--text-primary);\n}\n\n.reports-panel hr {\n  border-color: var(--border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
